import { useState } from "react";
import { Box, Tabs, Skeleton, Card, Badge } from '@mantine/core'
import { useRenovations } from '../hooks/useRenovations';
import { PageHeader } from '../components/common/PageHeader';
import { StatsGrid } from '../components/common/Stats';
import RenovationTable from '../components/Home/RenovationTable'
import ModalRenovation from '../components/Home/Modal';

const Home = () => {
  const { 
    items, 
    loading, 
    searchText, 
    today, 
    tenDays, 
    stats, 
    handleSearch, 
    handleClear, 
    refresh 
  } = useRenovations('10-days');

  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsOpen] = useState(false);

  const onOpenModal = (item) => {
    setSelectedItem(item);
    setIsOpen(true);
  };

  const onCloseModal = () => {
    setIsOpen(false);
    setSelectedItem(null);
    refresh();
  };

  const categorized = {
    all: items,
    postpago: items.filter(i => i.type_contract === 'Postpago'),
    prepago: items.filter(i => i.type_contract === 'Prepago')
  };

  return (
    <Box className='w-full pt-2 px-2'>
      <PageHeader 
        title="Próximos Vencimientos"
        subtitle="Monitor de cuentas críticas (10 días)"
        searchValue={searchText}
        onSearchChange={handleSearch}
        onSearchClick={() => handleSearch(searchText)}
        onClear={handleClear}
        placeholder="Buscar por cuenta o nombre..."
      />

      <StatsGrid data={stats} />

      <Box className='py-1 rounded'>
        {loading ? (
          <LoadingSkeleton />
        ) : (
          <Tabs defaultValue="all" variant='pills' color='yellow' className='w-full'>
            <Tabs.List px="md" mb="md">
              <TabLabel value="all" label="Todos" count={categorized.all.length} color="yellow" />
              <TabLabel value="postpago" label="Postpago" count={categorized.postpago.length} />
              <TabLabel value="prepago" label="Prepago" count={categorized.prepago.length} />
            </Tabs.List>

            {Object.entries(categorized).map(([key, data]) => (
              <Tabs.Panel key={key} value={key}>
                <RenovationTable 
                  items={data} 
                  today={today} 
                  tenDays={tenDays} 
                  openModal={onOpenModal} 
                />
              </Tabs.Panel>
            ))}
          </Tabs>
        )}
      </Box>

      <ModalRenovation 
        isOpen={isModalOpen} 
        onClose={onCloseModal} 
        item={selectedItem} 
      />
    </Box>
  );
};

const TabLabel = ({ value, label, count, color = "gray" }) => (
  <Tabs.Tab value={value}>
    {label} <Badge size="xs" ml={6} color={color} variant={color === 'yellow' ? 'filled' : 'light'}>{count}</Badge>
  </Tabs.Tab>
);

const LoadingSkeleton = () => (
  <Card shadow="md" p="xl" radius="lg" withBorder mx="md" w="100%">
    {[1, 2, 3, 4, 5].map((_, i) => (
      <Skeleton key={i} height={50} radius="md" my="xs" />
    ))}
  </Card>
);

export default Home;
